import { Component } from '@angular/core';
import { MonitorComponent } from '../../monitor.component';
import { MonitorEndpointsService } from '../../../common';
import { NewTokenData } from '../../../common/_types/pusher.types';
import {
  tokenIntvertColorFlashAnimation,
  FlashItem,
  triggerFlash,
  onFlashDone,
} from '../../../common/common.animation';

@Component({
  selector: 'app-monitor-token-display',
  templateUrl: './monitor-token-display.component.html',
  styleUrls: ['./monitor-token-display.component.scss'],
  providers: [MonitorEndpointsService],
  animations: [tokenIntvertColorFlashAnimation()],
})
export class MonitorTokenDisplayComponent extends MonitorComponent {
  public flashItem: FlashItem = { flag: false, state: 'original' };
  public latestTokenNumber = '';

  private triggerTokenAnimation = () => triggerFlash(this.flashItem);
  public monitorItemAnimationDone = () => onFlashDone(this.flashItem);

  private syncLatestTokenNumber(): void {
    const latest = this.monitorRows.reduce((acc, row) => {
      return (row.lastServingTokenId || 0) > (acc?.lastServingTokenId || 0) ? row : acc;
    }, null);
    this.latestTokenNumber = latest?.tokenNumber || '';
  }

  onMonitorDataLoadedHook(): void {
    super.onMonitorDataLoadedHook();
    this.syncLatestTokenNumber();
  }

  onNewTokenServingHook(payload?: NewTokenData): void {
    super.onNewTokenServingHook(payload);
    this.syncLatestTokenNumber();
  }

  triggerMonitorItemAnimation(): void {
    this.triggerTokenAnimation();
  }
}
